module.exports = __webpack_public_path__ + "static/Srikandi-618d368af004eb50f2e0bc797ef0d3b6.png";